export const CRASH_GAME = '/crash-game'
export const PLINKO_GAME = '/plinko-game'
export const WALLET = '/wallet'
export const SYSTEM = '/system'
export const BALLOON_PUMP_GAME = '/balloon-pump-game'
export const BOTTLE_MANIA_GAME = '/bottle-mania-game'

export const SOCKET_EMITTERS = {
  BALLOON_PUMP_GAME_PLACE_BET: BALLOON_PUMP_GAME + '/placeBet',
  BALLOON_PUMP_GAME_PLAY_GAME: BALLOON_PUMP_GAME + '/playGame',
  BALLOON_PUMP_GAME_CASH_OUT: BALLOON_PUMP_GAME + '/cashOutBet',
  BOTTLE_MANIA_GAME_PLACE_BET: BOTTLE_MANIA_GAME + '/placeBet',
  BOTTLE_MANIA_GAME_PLAY_GAME: BOTTLE_MANIA_GAME + '/playGame',
  BOTTLE_MANIA_GAME_CASH_OUT: BOTTLE_MANIA_GAME + '/cashOutBet'
}

export const SOCKET_LISTENERS = {
  BALLOON_PUMP_GAME_PLACE_BET: BALLOON_PUMP_GAME + '/placeBet',
  BALLOON_PUMP_GAME_PLAY_GAME: BALLOON_PUMP_GAME + '/playGame',
  BALLOON_PUMP_GAME_CASH_OUT: BALLOON_PUMP_GAME + '/cashOut',
  BALLOON_PUMP_GAME_BUSTED_GAME: BALLOON_PUMP_GAME + '/bustedGame',
  BOTTLE_MANIA_GAME_PLACE_BET: BOTTLE_MANIA_GAME + '/placeBet',
  BOTTLE_MANIA_GAME_PLAY_GAME: BOTTLE_MANIA_GAME + '/playGame',
  BOTTLE_MANIA_GAME_CASH_OUT: BOTTLE_MANIA_GAME + '/cashOut',
  BOTTLE_MANIA_GAME_BUSTED_GAME: BOTTLE_MANIA_GAME + '/bustedGame'
}
